const SituacaoRemessaEnum = {
  'EM_PROCESSAMENTO': 'P',
  'CONCLUIDO': 'C',
  'ERRO': 'E',
  'N_A': 'D',
  'AGUARDANDO_EXCLUSAO': 'X',
  'AGUARDANDO_PROCESSAMENTO': 'A',
  'REPROCESSANDO': 'R'
}

export default SituacaoRemessaEnum



// WEBPACK FOOTER //
// ./client/enum/situacaoRemessa.js